module.exports = __webpack_public_path__ + "img/pic_bt_jp.0ed1c2b8.png";